const ApiHeaderKey = {
    businessUnit: "x-businessunit",
    clientIp: "x-client-ip-address",
    correlationId: "x-correlation-id",
    country: "x-country-iso",
    gateway: "x-Gateway-APIKey",
    requestId: "x-request-id"
}

export default ApiHeaderKey;